import { Component, OnInit, Inject, EventEmitter, HostListener, ElementRef, ViewChild, OnDestroy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { LuxonDateAdapter } from '../../shared/services/luxon-date-adapter';
import { DateTime } from 'luxon';
import { DayTime, DayType } from '@signal/asp-data-commons';
import { DateAdapter } from '@angular/material/core';
import { TranslateService } from '@ngx-translate/core';
import { SubscriptionList } from '../../shared/models/asp.types';
import { getRandomValue, unsubscribeSubscriptions } from '../../shared/services/util.service';

@Component({
  selector: 'app-holiday',
  templateUrl: './holiday.component.html',
  styleUrls: ['./holiday.component.scss']
})
export class HolidayComponent implements OnInit, OnDestroy {
  holidayForm: UntypedFormGroup;
  popupTitle: string = 'departmentHolidays.addNewHoliday';
  popupSaveTitle: string = 'departmentHolidays.addnew';
  public onAdd: any = new EventEmitter();
  public onEdit: any = new EventEmitter();
  clickedOutside=false;
  @ViewChild('form') form: ElementRef;
  private subs: SubscriptionList = {};

  constructor(
    public readonly dialogRef: MatDialogRef<HolidayComponent>,
    public readonly formBuilder: UntypedFormBuilder,
    @Inject(MAT_DIALOG_DATA) public readonly data: any,
    private luxonAdapter: LuxonDateAdapter,
    private readonly translate: TranslateService,
    private readonly dateAdapter: DateAdapter<Date>) {
    this.initiateForm();
    this.dateAdapter.setLocale(this.translate.currentLang);
  }
  
  @HostListener("document:click", ['$event.target'])
  showMessage(event)
  {    
    if (!this.form.nativeElement.contains(event) )
    {
      if( this.data.clicked) {
        this.data.clicked=false;
      }
      else{
        this.clickedOutside=true;
      }
    }
  }

  ngOnInit() {
    if (this.isUpdate()) { //For update
      const dataValue = {...this.data.payload,  holidayDate: DateTime.fromFormat(this.data.payload.holidayDate, 'yyyy-MM-dd').toISO() || ''};
      this.holidayForm.patchValue(dataValue);
      this.popupTitle = 'departmentHolidays.editHoliday';
      this.popupSaveTitle = 'overrideCapacity.save';
    }
    if(!this.isUpdate()){
      this.subs.dayTypeChnages = this.holidayForm.controls['dayType'].valueChanges.subscribe(value=>{
        if(value === DayType.half){
          this.holidayForm.controls['dayTime'].patchValue('AM');
        }else{
          this.holidayForm.controls['dayTime'].patchValue('NA');
        }
      })
    }

    
  }
  isUpdate() {
    let result: boolean = false;
    if (Object.keys(this.data.payload).length > 0) {
      result = true;
    }
    return result;
  }

  initiateForm() {
    this.holidayForm = this.formBuilder.group({
      holidayId: [(Math.floor(getRandomValue() * 10000))],
      holidayName: ['', Validators.required],
      holidayDate: [null, Validators.required],
      holidayYear: null,
      isRecurring: [false],
      department: '',
      dayType: [DayType],
      dayTime: [DayTime]
    });
    this.holidayForm.controls["dayType"].patchValue("FULL")
    this.holidayForm.controls["dayTime"].patchValue("NA")
  }

  save() {
    const formValue = this.holidayForm.value;
    formValue.holidayDate = this.luxonAdapter.parse(formValue.holidayDate, undefined).toFormat('yyyy-MM-dd');
    formValue.holidayYear = this.luxonAdapter.parse(formValue.holidayDate, 'yyyy-MM-dd').toFormat('yyyy');
    formValue.holidayYear = Number(formValue.holidayYear);
    if (this.isUpdate()) {
      this.onEdit.emit(formValue);
    }
    else {
      this.onAdd.emit(formValue);
    }

    this.close();
  }

  close() {
    this.dialogRef.close();
  }

  ngOnDestroy() {
    unsubscribeSubscriptions(this.subs);
  }

}
